import Http from './http'

/**
 * The platform's own financial position, read from the double-entry ledger.
 *
 * Distinct from affiliates.service and the per-product payout screens, which
 * each report one product's idea of what is owed. These endpoints answer across
 * all of them: what the platform actually earned as opposed to what merely
 * passed through it, and what it owes creators right now.
 */
export const financeOverview = (params = {}) => Http.get('/admin/finance/overview', { params })

export const financeLiabilities = (params = {}) => Http.get('/admin/finance/liabilities', { params })

/**
 * Which execution model — separate_transfer or destination_charge — is
 * currently active for each payout vertical. Admin-togglable, takes effect
 * immediately (no deploy): see PayoutFeature::executionMode() in api-main.
 */
export const financeExecutionModes = () => Http.get('/admin/finance/execution-mode')

export const updateFinanceExecutionMode = (vertical, executionMode) =>
	Http.patch(`/admin/finance/execution-mode/${vertical}`, { execution_mode: executionMode })

/**
 * The payout master switch, per-vertical payout capability, and pilot
 * allowlist — used to be .env-only (FINANCE_PAYOUTS_ENABLED and friends),
 * now admin-togglable, no deploy: see PayoutFeature in api-main.
 */
export const financePayoutFlags = () => Http.get('/admin/finance/payouts')

export const updateFinancePayoutsEnabled = (enabled) =>
	Http.patch('/admin/finance/payouts/enabled', { enabled })

export const updateFinanceVerticalPayout = (vertical, payout) =>
	Http.patch(`/admin/finance/payouts/${vertical}`, { payout })

export const updateFinancePayoutAllowlist = (userIds) =>
	Http.put('/admin/finance/payouts/allowlist', { user_ids: userIds })
